import type { JSONContent } from '@tiptap/core';
import type { InvestmentLabelLanguage } from '@/types';
import type { PricingType } from '@/theme/uboTheme';

export type { InvestmentLabelLanguage };

export function normalizeInvestmentLabelLanguage(x: unknown): InvestmentLabelLanguage {
  return x === 'en' ? 'en' : 'nl';
}

/** Kolomkoppen + totaalregel; komt overeen met InvestmentBlockContent.tableLabels + totalRow. */
export type InvestmentTableLabelsResolved = {
  description: string;
  hourlyRate: string;
  amountHours: string;
  subtotal: string;
  priceExTax: string;
  /** Achtervoegsel na "Totaal "/"Total " in PDF (legacy). */
  exTax: string;
  /** Volledige regeltekst onder de tabel (editor + preview). */
  totalRow: string;
};

const NL: InvestmentTableLabelsResolved = {
  description: 'Omschrijving',
  hourlyRate: 'Uurtarief',
  amountHours: 'Uren',
  subtotal: 'Subtotaal',
  priceExTax: 'Prijs excl. BTW',
  exTax: 'excl. BTW',
  totalRow: 'Totaal excl. BTW',
};

const EN: InvestmentTableLabelsResolved = {
  description: 'Description',
  hourlyRate: 'Hourly rate',
  amountHours: 'Hours',
  subtotal: 'Subtotal',
  priceExTax: 'Price excl. VAT',
  exTax: 'excl. VAT',
  totalRow: 'Total excl. VAT',
};

export function getInvestmentTableLabels(lang: InvestmentLabelLanguage): InvestmentTableLabelsResolved {
  return lang === 'en' ? EN : NL;
}

function tableHeaderCell(text: string): JSONContent {
  return {
    type: 'tableHeader',
    content: [{ type: 'paragraph', content: [{ type: 'text', text }] }],
  };
}

/** Eerste rij (koppen) van een investeringstabel voor de gegeven prijs-soort. */
export function buildInvestmentHeaderRowJson(
  pt: PricingType,
  L: InvestmentTableLabelsResolved,
): JSONContent {
  if (pt === 'hourly') {
    return {
      type: 'tableRow',
      content: [
        tableHeaderCell(L.description),
        tableHeaderCell(L.hourlyRate),
        tableHeaderCell(L.amountHours),
        tableHeaderCell(L.subtotal),
      ],
    };
  }
  if (pt === 'fixed') {
    return {
      type: 'tableRow',
      content: [tableHeaderCell(L.description)],
    };
  }
  return {
    type: 'tableRow',
    content: [tableHeaderCell(L.description), tableHeaderCell(L.priceExTax)],
  };
}
